import { useEffect, useState } from "react";
import { useSignalR } from "../context/SignalRProvider";
import { SIGNALR_STATUS } from "../types/signalRConnection.types";
import { useIsAdmin } from "./useIsAdmin";
import { useIsCustomer } from "./useIsCustomer";

export function useSignalRConnectionStatus() {
  const service = useSignalR();
  const isAdmin = useIsAdmin();
  const isCustomer = useIsCustomer();
  const showStatus = isAdmin || isCustomer;
  const [status, setStatus] = useState(
    () => service?.getConnectionStatus?.() ?? SIGNALR_STATUS.IDLE,
  );

  useEffect(() => {
    if (!showStatus) {
      setStatus(SIGNALR_STATUS.IDLE);
      return undefined;
    }

    return service.onStatusChange(setStatus);
  }, [service, showStatus]);

  return { status, isAdmin, isCustomer, showStatus };
}

export default useSignalRConnectionStatus;
